import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PROVINCES } from '../shared/data/provinces';
import { Province } from '../Models/province';


@Component({
  selector: 'provincedialog',
  templateUrl: './province-dialog.component.html',
  styleUrls: ['./province-dialog.component.scss'],
  providers: []
})
export class ProvinceDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ProvinceDialogComponent>) { }
  allProvinces: AllProvinces[] = new Array<AllProvinces>();
  selectedProvinces: Province[] = new Array<Province>();

  ngOnInit() {
    for (let i = 0; i < PROVINCES.length; i++) {
      this.allProvinces[i] = { province: PROVINCES[i], isSelected: false };
      if (this.selectedProvinces.findIndex(x => x.provinceId == this.allProvinces[i].province.provinceId) != -1) {
        this.allProvinces[i].isSelected = true;
      }
    }
  }

  changeSelectedProvincesList(province: Province, event) {
    if (event.checked) {
      this.selectedProvinces.push(province);
    } else {
      this.selectedProvinces.splice(this.selectedProvinces.findIndex(x => x.provinceId == province.provinceId), 1);
    }
    
  }
}

export class AllProvinces {
  province: Province = new Province();
  isSelected: boolean;
}
